import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <section className="footer_section">
        <div className="container-fluid">
          <div className="row justify-content-center mb-4">
            <div className="col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
              <div className="footlogodiv">
                <Link to="/home">
                  <img
                    className="footlogoimg"
                    src="/Assets/images/footer/footer-logo.png"
                    alt="Gymify Logo"
                  />
                </Link>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-2 col-md-3 col-sm-3 col-6 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Quick Links</h6>

                <div className="menudiv">
                  <Link
                    to="/home"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    About Us
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    to="/home"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Why to Choose Us?
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    to="/home"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Contact Us
                  </Link>
                </div>
                <div className="menudiv">
                  <Link
                    to="/terms-conditions-user"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Term & Conditions (Users)
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    to="/terms-conditions-owner"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Term & Conditions (Owners)
                  </Link>
                </div>

                <div className="menudiv">
                  <Link
                    to="/privacy-policy"
                    onClick={() => {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Privacy Policy
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-3 col-6 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Contact Us</h6>
                <div className="menudiv">
                  <p>+91 9876543210</p>
                  <p>gymify@gmail.com</p>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-3 col-6 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Download App</h6>
                <div className="img_holder">
                  <img
                    src="/Assets/images/footer/playstore.png"
                    alt="playstore"
                    className="playstore_btn"
                    onClick={() =>
                      window.open("https://play.google.com", "_blank")
                    }
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-3 col-6 mb-3">
              <div className="menusec">
                <h6 className="menutitle">Follow us</h6>

                <div className="icon_holder_div">
                  <div className="icon_holder">
                    <a
                      href="https://www.facebook.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faFacebookF}
                        className="icons"
                        style={{ color: "#fff" }}
                      />
                    </a>
                  </div>

                  <div className="icon_holder">
                    <a
                      href="https://www.instagram.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faInstagram}
                        className="icons"
                        style={{ color: "#fff" }}
                      />
                    </a>
                  </div>

                  <div className="icon_holder">
                    <a
                      href="https://www.youtube.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon
                        icon={faYoutube}
                        className="icons"
                        style={{ color: "#fff" }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="copyrightsec">
            <p className="addressp">
              Akshya Nagar 1st Block 1st Cross, Rammurthy nagar, Pune - 411038
            </p>
            <hr className="divider" />
            <p className="copyrightp">
              © All Rights Reserved | Developed by{" "}
              <Link to={"https://profcymaglobal.com/"} target="_blank">
                Profcyma Solutions Pvt Ltd
              </Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
